export const sidebar = {
      development: 'Catálogo técnico',
      dashboard: 'Inicio',
      products: 'Productos',
      inventory: 'Inventario',
      movements: 'Movimientos',
      reports: 'Reportes',
      settings: 'Configuración',
      logout: 'Cerrar sesión',
    } as const;
